import React, { useContext, useEffect, useState } from 'react';
import { useRoom } from '../context/RoomContext.jsx';

import GameContainer from '../components/GameContainer.jsx';
import AvatarSelector from '../components/AvatarSelector.jsx';
import NickNameSelector from '../components/NickNameSelector.jsx';
import SplashScreen from '../components/SplashScreen.jsx';
import { AuthContext } from '../context/AuthContext.jsx';

const Demo = () => {
	const { sessionInfo } = useContext(AuthContext);
	const { roomState } = useRoom();
	const [showSplash, setShowSplash] = useState(true);

	// Timer per nascondere lo splash screen dopo 5 secondi
	useEffect(() => {
		const timer = setTimeout(() => {
			setShowSplash(false);
		}, 7000);

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		if (!sessionInfo) return;
		const colorPreset = (sessionInfo.template?.colorPreset || 'default').replace(/[A-Z]/g, m => "-" + m.toLowerCase());
		document.querySelector('body').className = '';
		document.querySelector('body').classList.add('trivia' + (colorPreset));
		//const gameContainer = document.getElementById('game-container')
		//if (gameContainer) gameContainer.style.minHeight = `calc(100vh - ${document.querySelector('footer')?.offsetHeight}px)`;
	}, [sessionInfo]);

	const render = () => {

		if (!sessionInfo.nickName && sessionInfo.sessionType === 1) {
			return <NickNameSelector />;
		}
		if (!sessionInfo.currentAvatarId && sessionInfo.sessionType === 1) {
			return <AvatarSelector />;
		}

		return <GameContainer />;
	}

	return (
		<>
			{sessionInfo && (
				<>
					{sessionInfo.template?.backgroundMediaId ?
						<img className="bg-image" src={`/api/trivia/media/${sessionInfo.template.backgroundMediaId}`} />
						: ""}
					{showSplash ? (
						<SplashScreen onClick={() => setShowSplash(false)} />
					) : (
						<>
							{render()}
						</>
					)}
				</>
			)}
		</>
	);
};

export default Demo;
